import { css } from '@emotion/react';
import { button } from './buttonStyles';

export * from './nppTheme';
export * from './fieldStyles';

export const globalNppStyles = css`
  ${button}
`;
